/**
 * Stable CSS class names for E2E — RPA Resend page.
 */
export const RPAR = {
    page: 'rpa-resend-page',
    breadcrumbSection: 'rpa-resend-page__breadcrumb-section',

    tabsSection: 'rpa-resend-page__tabs-section',
    formSection: 'rpa-resend-page__form-section',
    form: 'rpa-resend-page__form',
    formGrid: 'rpa-resend-page__form-grid',

    shippingNumbersField: 'rpa-resend-page-input__shipping-numbers',
    submitButton: 'rpa-resend-page-input--button-submit',

    actionsRow: 'rpa-resend-page__actions-row',
    sendRpaButton: 'rpa-resend-page-input--button-send-rpa-mail',
    bulkRpaButton: 'rpa-resend-page-input--button-bulk-rpa',

    shippingTypeTabsWrap: 'rpa-resend-page__shipping-type-tabs-wrap',
    notFoundSection: 'rpa-resend-page__not-found-section',
    notFoundText: 'rpa-resend-page__not-found-text',

    loadingSection: 'rpa-resend-page__loading-section',

    rpaGridWrap: 'rpa-resend-page__rpa-grid-wrap',
    resendGridWrap: 'rpa-resend-page__resend-grid-wrap',

    cellActionButtonSendRpa: 'rpa-resend-page-input--button-cell-send-rpa',
    cellActionButtonDownloadLabel: 'rpa-resend-page-input--button-cell-download-cargo-label',

    reportSection: 'rpa-resend-page__report-section',
    reportFullListButton: 'rpa-resend-page-input--button-report-full-list',
} as const;

export const rparCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
